import { create } from "zustand";

type AllowanceRequest = {
  id: string;
  reason: string;
  status: string;
  employeeName: string;
  employeeEmail: string;
  createdAt: string | Date;
  attachment?: string;
} | null;

interface HookProps {
  open: boolean;
  allowanceRequest: AllowanceRequest;
  onOpenChange: (open: boolean) => void;
  setAllowanceRequest: (ar: AllowanceRequest) => void;
}

export const useViewModal = create<HookProps>()((set) => ({
  open: false,
  allowanceRequest: null,
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
  setAllowanceRequest: (ar) =>
    set(() => ({
      allowanceRequest: ar,
    })),
}));
